import { render, staticRenderFns } from "./UserDataModal.vue?vue&type=template&id=ba512d0e&scoped=true&"
import script from "./UserDataModal.vue?vue&type=script&lang=js&"
export * from "./UserDataModal.vue?vue&type=script&lang=js&"
import style0 from "./UserDataModal.vue?vue&type=style&index=0&id=ba512d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba512d0e",
  null
  
)

export default component.exports